import { configureStore } from '@reduxjs/toolkit';
import { baseApi } from 'services/baseApi';
import statusActive from './sliceActiveTab';
import attachmentTypeReducer from './attachmentTypesSlice'; // hoặc './attachmentTypeSlice'
import tableCacheSlice from './slices/tableCacheSlice';
const store = configureStore({
  reducer: {
    // Add the API reducer
    [baseApi.reducerPath]: baseApi.reducer,
    status: statusActive,
    attachmentType: attachmentTypeReducer,
    tableCache: tableCacheSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
